export const INITIAL_DATE = '2015-01-01T00:15';

export const SELECIONAR_SOCIO = 'Seleccionar socio';
